import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { grey } from "@material-ui/core/colors"
import { withStyles } from "@material-ui/core/styles"
import ProductHeroLayout from "../ProductHeroLayout"
import isMobile from "../../../lib/isMobile"
import PossibleResult from "./PossibleResult"
import NotPossibleResult from "./NotPossibleResult"

const styles = (theme) => ({
  root: {
    color: theme.palette.common.black,
    [theme.breakpoints.up("sm")]: {
      height: "auto",
      minHeight: 500,
      maxHeight: 1300,
    },
  },
  background: {
    backgroundColor: grey[50],
    backgroundPosition: "center",
  },
  backdrop: {
    opacity: 0,
  },
  container: {
    marginTop: theme.spacing(6),
  },
})

function isPossible(answers) {
  const symptomsStep1 = Object.values(answers.questionsStep1).filter(
    (value) => value.checked
  )

  const symptomsStep2 = Object.values(answers.questionsStep2).filter(
    (value) => value.checked
  )

  const possibleContact = answers.questionsStep3.value === "yes"

  return possibleContact || symptomsStep1.length + symptomsStep2.length > 2
}

function Results(props) {
  const { classes, answers } = props
  const [isMobileState, setIsMobileState] = useState(true)

  useEffect(() => {
    setIsMobileState(isMobile())
  }, [isMobileState])

  function trackResult() {
    if (!window.analytics) return
    window.analytics.track(isPossible(answers) ? "sospechoso" : "no-sospechoso")
  }

  useEffect(() => {
    setTimeout(trackResult, 500)
  }, [])

  if (!answers) return null
  const result = isPossible(answers)

  return (
    <ProductHeroLayout
      backgroundClassName={classes.background}
      classes={classes}
    >
      {result && <PossibleResult isMobile={isMobileState} />}
      {!result && <NotPossibleResult isMobile={isMobileState} />}
    </ProductHeroLayout>
  )
}

Results.propTypes = {
  question: PropTypes.object,
  next: PropTypes.string,
}

export default withStyles(styles)(Results)
